
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("24DUy", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", function () { return $8d1ccc98aa9166ca$export$deee3a793edee05f; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");
parcelRequire("kSdhf");
var $ft7ke = parcelRequire("ft7ke");
var $kSdhf = parcelRequire("kSdhf");

var $ft7ke = parcelRequire("ft7ke");

var $1aw9F = parcelRequire("1aw9F");
function $8d1ccc98aa9166ca$var$getCssDimensions(element) {
    const css = (0, $1aw9F.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $1aw9F.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $ft7ke.round)(width) !== offsetWidth || (0, $ft7ke.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $8d1ccc98aa9166ca$var$unwrapElement(element) {
    return !(0, $1aw9F.isElement)(element) ? element.contextElement : element;
}
function $8d1ccc98aa9166ca$var$getScale(element) {
    const domElement = $8d1ccc98aa9166ca$var$unwrapElement(element);
    if (!(0, $1aw9F.isHTMLElement)(domElement)) return (0, $ft7ke.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $8d1ccc98aa9166ca$var$getCssDimensions(domElement);
    let x = ($ ? (0, $ft7ke.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $ft7ke.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $8d1ccc98aa9166ca$var$noOffsets = /*#__PURE__*/ (0, $ft7ke.createCoords)(0);
function $8d1ccc98aa9166ca$var$getVisualOffsets(element) {
    const win = (0, $1aw9F.getWindow)(element);
    if (!(0, $1aw9F.isWebKit)() || !win.visualViewport) return $8d1ccc98aa9166ca$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $8d1ccc98aa9166ca$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $1aw9F.getWindow)(element)) return false;
    return isFixed;
}
function $8d1ccc98aa9166ca$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $8d1ccc98aa9166ca$var$unwrapElement(element);
    let scale = (0, $ft7ke.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $1aw9F.isElement)(offsetParent)) scale = $8d1ccc98aa9166ca$var$getScale(offsetParent);
        } else scale = $8d1ccc98aa9166ca$var$getScale(element);
    }
    const visualOffsets = $8d1ccc98aa9166ca$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $8d1ccc98aa9166ca$var$getVisualOffsets(domElement) : (0, $ft7ke.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $1aw9F.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $1aw9F.isElement)(offsetParent) ? (0, $1aw9F.getWindow)(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $8d1ccc98aa9166ca$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $1aw9F.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = (0, $1aw9F.getWindow)(currentIFrame).frameElement;
        }
    }
    return (0, $ft7ke.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $8d1ccc98aa9166ca$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = (0, $1aw9F.isHTMLElement)(offsetParent);
    const documentElement = (0, $1aw9F.getDocumentElement)(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $ft7ke.createCoords)(1);
    const offsets = (0, $ft7ke.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ((0, $1aw9F.getNodeName)(offsetParent) !== "body" || (0, $1aw9F.isOverflowElement)(documentElement)) scroll = (0, $1aw9F.getNodeScroll)(offsetParent);
        if ((0, $1aw9F.isHTMLElement)(offsetParent)) {
            const offsetRect = $8d1ccc98aa9166ca$var$getBoundingClientRect(offsetParent);
            scale = $8d1ccc98aa9166ca$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $8d1ccc98aa9166ca$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $8d1ccc98aa9166ca$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $8d1ccc98aa9166ca$var$getBoundingClientRect((0, $1aw9F.getDocumentElement)(element)).left + (0, $1aw9F.getNodeScroll)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $8d1ccc98aa9166ca$var$getDocumentRect(element) {
    const html = (0, $1aw9F.getDocumentElement)(element);
    const scroll = (0, $1aw9F.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $ft7ke.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $ft7ke.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $8d1ccc98aa9166ca$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $1aw9F.getComputedStyle)(body).direction === "rtl") x += (0, $ft7ke.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $8d1ccc98aa9166ca$var$getViewportRect(element, strategy) {
    const win = (0, $1aw9F.getWindow)(element);
    const html = (0, $1aw9F.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $1aw9F.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $8d1ccc98aa9166ca$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $8d1ccc98aa9166ca$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $1aw9F.isHTMLElement)(element) ? $8d1ccc98aa9166ca$var$getScale(element) : (0, $ft7ke.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $8d1ccc98aa9166ca$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $8d1ccc98aa9166ca$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $8d1ccc98aa9166ca$var$getDocumentRect((0, $1aw9F.getDocumentElement)(element));
    else if ((0, $1aw9F.isElement)(clippingAncestor)) rect = $8d1ccc98aa9166ca$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $8d1ccc98aa9166ca$var$getVisualOffsets(element);
        rect = (0, $6iHNw._)((0, $7Knp0._)({}, clippingAncestor), {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        });
    }
    return (0, $ft7ke.rectToClientRect)(rect);
}
function $8d1ccc98aa9166ca$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $1aw9F.getParentNode)(element);
    if (parentNode === stopNode || !(0, $1aw9F.isElement)(parentNode) || (0, $1aw9F.isLastTraversableNode)(parentNode)) return false;
    return (0, $1aw9F.getComputedStyle)(parentNode).position === "fixed" || $8d1ccc98aa9166ca$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $8d1ccc98aa9166ca$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $1aw9F.getOverflowAncestors)(element, [], false).filter((el)=>(0, $1aw9F.isElement)(el) && (0, $1aw9F.getNodeName)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $1aw9F.getComputedStyle)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $1aw9F.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $1aw9F.isElement)(currentNode) && !(0, $1aw9F.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $1aw9F.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $1aw9F.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $1aw9F.isOverflowElement)(currentNode) && !currentNodeIsContaining && $8d1ccc98aa9166ca$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $1aw9F.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $8d1ccc98aa9166ca$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $8d1ccc98aa9166ca$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $8d1ccc98aa9166ca$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $ft7ke.max)(rect.top, accRect.top);
        accRect.right = (0, $ft7ke.min)(rect.right, accRect.right);
        accRect.bottom = (0, $ft7ke.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $ft7ke.max)(rect.left, accRect.left);
        return accRect;
    }, $8d1ccc98aa9166ca$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $8d1ccc98aa9166ca$var$getDimensions(element) {
    return $8d1ccc98aa9166ca$var$getCssDimensions(element);
}
function $8d1ccc98aa9166ca$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $1aw9F.isHTMLElement)(offsetParent);
    const documentElement = (0, $1aw9F.getDocumentElement)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $8d1ccc98aa9166ca$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $ft7ke.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1aw9F.getNodeName)(offsetParent) !== "body" || (0, $1aw9F.isOverflowElement)(documentElement)) scroll = (0, $1aw9F.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $8d1ccc98aa9166ca$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $8d1ccc98aa9166ca$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $8d1ccc98aa9166ca$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $1aw9F.isHTMLElement)(element) || (0, $1aw9F.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $8d1ccc98aa9166ca$var$getOffsetParent(element, polyfill) {
    const window = (0, $1aw9F.getWindow)(element);
    if (!(0, $1aw9F.isHTMLElement)(element)) return window;
    let offsetParent = $8d1ccc98aa9166ca$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $1aw9F.isTableElement)(offsetParent) && (0, $1aw9F.getComputedStyle)(offsetParent).position === "static")offsetParent = $8d1ccc98aa9166ca$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $1aw9F.getNodeName)(offsetParent) === "html" || (0, $1aw9F.getNodeName)(offsetParent) === "body" && (0, $1aw9F.getComputedStyle)(offsetParent).position === "static" && !(0, $1aw9F.isContainingBlock)(offsetParent))) return window;
    return offsetParent || (0, $1aw9F.getContainingBlock)(element) || window;
}
const $8d1ccc98aa9166ca$var$getElementRects = async function(_ref) {
    let { reference: reference, floating: floating, strategy: strategy } = _ref;
    const getOffsetParentFn = this.getOffsetParent || $8d1ccc98aa9166ca$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $8d1ccc98aa9166ca$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: (0, $7Knp0._)({
            x: 0,
            y: 0
        }, await getDimensionsFn(floating))
    };
};
function $8d1ccc98aa9166ca$var$isRTL(element) {
    return (0, $1aw9F.getComputedStyle)(element).direction === "rtl";
}
const $8d1ccc98aa9166ca$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $8d1ccc98aa9166ca$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $1aw9F.getDocumentElement,
    getClippingRect: $8d1ccc98aa9166ca$var$getClippingRect,
    getOffsetParent: $8d1ccc98aa9166ca$var$getOffsetParent,
    getElementRects: $8d1ccc98aa9166ca$var$getElementRects,
    getClientRects: $8d1ccc98aa9166ca$var$getClientRects,
    getDimensions: $8d1ccc98aa9166ca$var$getDimensions,
    getScale: $8d1ccc98aa9166ca$var$getScale,
    isElement: $1aw9F.isElement,
    isRTL: $8d1ccc98aa9166ca$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $8d1ccc98aa9166ca$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $1aw9F.getDocumentElement)(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $ft7ke.floor)(top);
        const insetRight = (0, $ft7ke.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $ft7ke.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $ft7ke.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $ft7ke.max)(0, (0, $ft7ke.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, (0, $6iHNw._)((0, $7Knp0._)({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $8d1ccc98aa9166ca$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $8d1ccc98aa9166ca$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $1aw9F.getOverflowAncestors)(referenceEl) : [],
        ...(0, $1aw9F.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $8d1ccc98aa9166ca$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $8d1ccc98aa9166ca$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $8d1ccc98aa9166ca$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $8d1ccc98aa9166ca$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = (0, $7Knp0._)({
        platform: $8d1ccc98aa9166ca$export$722a64dea1b767dc
    }, options);
    const platformWithCache = (0, $6iHNw._)((0, $7Knp0._)({}, mergedOptions.platform), {
        _c: cache
    });
    return (0, $kSdhf.computePosition)(reference, floating, (0, $6iHNw._)((0, $7Knp0._)({}, mergedOptions), {
        platform: platformWithCache
    }));
};

});
parcelRegister("kSdhf", function(module, exports) {

$parcel$export(module.exports, "computePosition", function () { return $9a5214747241b192$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "rectToClientRect", function () { return (parcelRequire("ft7ke")).rectToClientRect; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $ft7ke = parcelRequire("ft7ke");
function $9a5214747241b192$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $ft7ke.getSideAxis)(placement);
    const alignmentAxis = (0, $ft7ke.getAlignmentAxis)(placement);
    const alignLength = (0, $ft7ke.getAxisLength)(alignmentAxis);
    const side = (0, $ft7ke.getSide)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $ft7ke.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $9a5214747241b192$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $9a5214747241b192$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = (0, $6iHNw._)((0, $7Knp0._)({}, middlewareData), {
            [name]: (0, $7Knp0._)({}, middlewareData[name], data)
        });
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $9a5214747241b192$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $9a5214747241b192$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $ft7ke.evaluate)(options, state);
    const paddingObject = (0, $ft7ke.getPaddingObject)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $ft7ke.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? (0, $6iHNw._)((0, $7Knp0._)({}, rects.floating), {
        x: x,
        y: y
    }) : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $ft7ke.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9a5214747241b192$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $ft7ke.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $ft7ke.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $ft7ke.getAlignmentAxis)(placement);
            const length = (0, $ft7ke.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $ft7ke.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $ft7ke.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $ft7ke.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $ft7ke.getAlignment)(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: (0, $7Knp0._)({
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset
                }, shouldAddOffset && {
                    alignmentOffset: alignmentOffset
                }),
                reset: shouldAddOffset
            };
        }
    });
function $9a5214747241b192$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $ft7ke.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $ft7ke.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $ft7ke.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $ft7ke.getAlignment)(placement) === alignment || (autoAlignment ? (0, $ft7ke.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9a5214747241b192$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const _evaluate = (0, $ft7ke.evaluate)(options, state), { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $ft7ke.placements), autoAlignment: autoAlignment = true } = _evaluate, detectOverflowOptions = (0, $akGnX._)(_evaluate, [
                "crossAxis",
                "alignment",
                "allowedPlacements",
                "autoAlignment"
            ]);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $ft7ke.placements) ? $9a5214747241b192$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $9a5214747241b192$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $ft7ke.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $ft7ke.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $ft7ke.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $ft7ke.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9a5214747241b192$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const _evaluate = (0, $ft7ke.evaluate)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true } = _evaluate, detectOverflowOptions = (0, $akGnX._)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "fallbackPlacements",
                "fallbackStrategy",
                "fallbackAxisSideDirection",
                "flipAlignment"
            ]);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $ft7ke.getSide)(placement);
            const isBasePlacement = (0, $ft7ke.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $ft7ke.getOppositePlacement)(initialPlacement)
            ] : (0, $ft7ke.getExpandedPlacements)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $ft7ke.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $9a5214747241b192$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $ft7ke.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $9a5214747241b192$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $9a5214747241b192$var$isAnySideFullyClipped(overflow) {
    return (0, $ft7ke.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9a5214747241b192$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const _evaluate = (0, $ft7ke.evaluate)(options, state), { strategy: strategy = "referenceHidden" } = _evaluate, detectOverflowOptions = (0, $akGnX._)(_evaluate, [
                "strategy"
            ]);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $9a5214747241b192$export$37b6bde19b108ecc(state, (0, $6iHNw._)((0, $7Knp0._)({}, detectOverflowOptions), {
                            elementContext: "reference"
                        }));
                        const offsets = $9a5214747241b192$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $9a5214747241b192$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $9a5214747241b192$export$37b6bde19b108ecc(state, (0, $6iHNw._)((0, $7Knp0._)({}, detectOverflowOptions), {
                            altBoundary: true
                        }));
                        const offsets = $9a5214747241b192$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $9a5214747241b192$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $9a5214747241b192$var$getBoundingRect(rects) {
    const minX = (0, $ft7ke.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $ft7ke.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $ft7ke.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $ft7ke.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $9a5214747241b192$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $ft7ke.rectToClientRect)($9a5214747241b192$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9a5214747241b192$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $ft7ke.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $9a5214747241b192$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $ft7ke.rectToClientRect)($9a5214747241b192$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $ft7ke.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $ft7ke.getSideAxis)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $ft7ke.getSide)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $ft7ke.getSide)(placement) === "left";
                    const maxRight = (0, $ft7ke.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $ft7ke.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $9a5214747241b192$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $ft7ke.getSide)(placement);
    const alignment = (0, $ft7ke.getAlignment)(placement);
    const isVertical = (0, $ft7ke.getSideAxis)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $ft7ke.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : (0, $7Knp0._)({
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null
    }, rawValue);
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9a5214747241b192$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            const { x: x, y: y } = state;
            const diffCoords = await $9a5214747241b192$var$convertValueToCoords(state, options);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9a5214747241b192$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const _evaluate = (0, $ft7ke.evaluate)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            } } = _evaluate, detectOverflowOptions = (0, $akGnX._)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "limiter"
            ]);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $9a5214747241b192$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $ft7ke.getSideAxis)((0, $ft7ke.getSide)(placement));
            const mainAxis = (0, $ft7ke.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $ft7ke.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $ft7ke.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn((0, $6iHNw._)((0, $7Knp0._)({}, state), {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            }));
            return (0, $6iHNw._)((0, $7Knp0._)({}, limitedCoords), {
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            });
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9a5214747241b192$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $ft7ke.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $ft7ke.getSideAxis)(placement);
            const mainAxis = (0, $ft7ke.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $ft7ke.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : (0, $7Knp0._)({
                mainAxis: 0,
                crossAxis: 0
            }, rawOffset);
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $ft7ke.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9a5214747241b192$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const _evaluate = (0, $ft7ke.evaluate)(options, state), { apply: apply = ()=>{} } = _evaluate, detectOverflowOptions = (0, $akGnX._)(_evaluate, [
                "apply"
            ]);
            const overflow = await $9a5214747241b192$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $ft7ke.getSide)(placement);
            const alignment = (0, $ft7ke.getAlignment)(placement);
            const isYAxis = (0, $ft7ke.getSideAxis)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $ft7ke.min)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $ft7ke.min)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $ft7ke.max)(overflow.left, 0);
                const xMax = (0, $ft7ke.max)(overflow.right, 0);
                const yMin = (0, $ft7ke.max)(overflow.top, 0);
                const yMax = (0, $ft7ke.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $ft7ke.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $ft7ke.max)(overflow.top, overflow.bottom));
            }
            await apply((0, $6iHNw._)((0, $7Knp0._)({}, state), {
                availableWidth: availableWidth,
                availableHeight: availableHeight
            }));
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("ft7ke", function(module, exports) {

$parcel$export(module.exports, "sides", function () { return $a5cddb2008cdcd5d$export$832b6fa47fa053d2; });
$parcel$export(module.exports, "placements", function () { return $a5cddb2008cdcd5d$export$803cd8101b6c182b; });
$parcel$export(module.exports, "min", function () { return $a5cddb2008cdcd5d$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $a5cddb2008cdcd5d$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $a5cddb2008cdcd5d$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "floor", function () { return $a5cddb2008cdcd5d$export$a3fe094919f356fd; });
$parcel$export(module.exports, "createCoords", function () { return $a5cddb2008cdcd5d$export$a397704b5e280835; });
$parcel$export(module.exports, "clamp", function () { return $a5cddb2008cdcd5d$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "evaluate", function () { return $a5cddb2008cdcd5d$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getSide", function () { return $a5cddb2008cdcd5d$export$3c915306cb7fc97a; });
$parcel$export(module.exports, "getAlignment", function () { return $a5cddb2008cdcd5d$export$f0989780f32bfcda; });
$parcel$export(module.exports, "getOppositeAxis", function () { return $a5cddb2008cdcd5d$export$8a000a963141ac32; });
$parcel$export(module.exports, "getAxisLength", function () { return $a5cddb2008cdcd5d$export$320bd9d53520c68a; });
$parcel$export(module.exports, "getSideAxis", function () { return $a5cddb2008cdcd5d$export$f28e8f882010718a; });
$parcel$export(module.exports, "getAlignmentAxis", function () { return $a5cddb2008cdcd5d$export$2b57e0052a6d6d4c; });
$parcel$export(module.exports, "getAlignmentSides", function () { return $a5cddb2008cdcd5d$export$be42861551f17911; });
$parcel$export(module.exports, "getOppositePlacement", function () { return $a5cddb2008cdcd5d$export$9c5e28bad23365fa; });
$parcel$export(module.exports, "getExpandedPlacements", function () { return $a5cddb2008cdcd5d$export$496432a3699e50b1; });
$parcel$export(module.exports, "getOppositeAlignmentPlacement", function () { return $a5cddb2008cdcd5d$export$2b182c584985588b; });
$parcel$export(module.exports, "getOppositeAxisPlacements", function () { return $a5cddb2008cdcd5d$export$a9b6fb18fd92c3ec; });
$parcel$export(module.exports, "getPaddingObject", function () { return $a5cddb2008cdcd5d$export$598c291c29bc2e71; });
$parcel$export(module.exports, "rectToClientRect", function () { return $a5cddb2008cdcd5d$export$ee05aea0aeecbad4; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");
const $a5cddb2008cdcd5d$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $a5cddb2008cdcd5d$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $a5cddb2008cdcd5d$export$803cd8101b6c182b = /*#__PURE__*/ $a5cddb2008cdcd5d$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $a5cddb2008cdcd5d$export$27b07d8a310ed8b5[0], side + "-" + $a5cddb2008cdcd5d$export$27b07d8a310ed8b5[1]), []);
const $a5cddb2008cdcd5d$export$96ec731ed4dcb222 = Math.min;
const $a5cddb2008cdcd5d$export$8960430cfd85939f = Math.max;
const $a5cddb2008cdcd5d$export$2077e0241d6afd3c = Math.round;
const $a5cddb2008cdcd5d$export$a3fe094919f356fd = Math.floor;
const $a5cddb2008cdcd5d$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $a5cddb2008cdcd5d$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $a5cddb2008cdcd5d$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $a5cddb2008cdcd5d$export$7d15b64cf5a3a4c4(start, value, end) {
    return $a5cddb2008cdcd5d$export$8960430cfd85939f(start, $a5cddb2008cdcd5d$export$96ec731ed4dcb222(value, end));
}
function $a5cddb2008cdcd5d$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $a5cddb2008cdcd5d$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $a5cddb2008cdcd5d$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $a5cddb2008cdcd5d$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $a5cddb2008cdcd5d$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $a5cddb2008cdcd5d$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($a5cddb2008cdcd5d$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $a5cddb2008cdcd5d$export$2b57e0052a6d6d4c(placement) {
    return $a5cddb2008cdcd5d$export$8a000a963141ac32($a5cddb2008cdcd5d$export$f28e8f882010718a(placement));
}
function $a5cddb2008cdcd5d$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $a5cddb2008cdcd5d$export$f0989780f32bfcda(placement);
    const alignmentAxis = $a5cddb2008cdcd5d$export$2b57e0052a6d6d4c(placement);
    const length = $a5cddb2008cdcd5d$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $a5cddb2008cdcd5d$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $a5cddb2008cdcd5d$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $a5cddb2008cdcd5d$export$496432a3699e50b1(placement) {
    const oppositePlacement = $a5cddb2008cdcd5d$export$9c5e28bad23365fa(placement);
    return [
        $a5cddb2008cdcd5d$export$2b182c584985588b(placement),
        oppositePlacement,
        $a5cddb2008cdcd5d$export$2b182c584985588b(oppositePlacement)
    ];
}
function $a5cddb2008cdcd5d$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$a5cddb2008cdcd5d$var$oppositeAlignmentMap[alignment]);
}
function $a5cddb2008cdcd5d$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $a5cddb2008cdcd5d$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $a5cddb2008cdcd5d$export$f0989780f32bfcda(placement);
    let list = $a5cddb2008cdcd5d$var$getSideList($a5cddb2008cdcd5d$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($a5cddb2008cdcd5d$export$2b182c584985588b));
    }
    return list;
}
function $a5cddb2008cdcd5d$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$a5cddb2008cdcd5d$var$oppositeSideMap[side]);
}
function $a5cddb2008cdcd5d$export$1c66dbf1a9e34223(padding) {
    return (0, $7Knp0._)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function $a5cddb2008cdcd5d$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $a5cddb2008cdcd5d$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $a5cddb2008cdcd5d$export$ee05aea0aeecbad4(rect) {
    return (0, $6iHNw._)((0, $7Knp0._)({}, rect), {
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("1aw9F", function(module, exports) {

$parcel$export(module.exports, "getNodeName", function () { return $e7725b143600c9c2$export$651544f548703224; });
$parcel$export(module.exports, "getWindow", function () { return $e7725b143600c9c2$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "getDocumentElement", function () { return $e7725b143600c9c2$export$e495491855dc5418; });
$parcel$export(module.exports, "isElement", function () { return $e7725b143600c9c2$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $e7725b143600c9c2$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isOverflowElement", function () { return $e7725b143600c9c2$export$989e911fa9af580a; });
$parcel$export(module.exports, "getComputedStyle", function () { return $e7725b143600c9c2$export$3735103072e4a80; });
$parcel$export(module.exports, "isTableElement", function () { return $e7725b143600c9c2$export$71535ffaa902797f; });
$parcel$export(module.exports, "isContainingBlock", function () { return $e7725b143600c9c2$export$d6c4e8150c35fed1; });
$parcel$export(module.exports, "isWebKit", function () { return $e7725b143600c9c2$export$78551043582a6a98; });
$parcel$export(module.exports, "getContainingBlock", function () { return $e7725b143600c9c2$export$940d8225183e1404; });
$parcel$export(module.exports, "getParentNode", function () { return $e7725b143600c9c2$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "isLastTraversableNode", function () { return $e7725b143600c9c2$export$d1162fb0b6d4cd51; });
$parcel$export(module.exports, "getNodeScroll", function () { return $e7725b143600c9c2$export$dc8fc79fa2800137; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return $e7725b143600c9c2$export$3b57c1601291186b; });
function $e7725b143600c9c2$export$651544f548703224(node) {
    if ($e7725b143600c9c2$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $e7725b143600c9c2$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $e7725b143600c9c2$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($e7725b143600c9c2$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $e7725b143600c9c2$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $e7725b143600c9c2$export$38b2d434cce3ea22(value).Node;
}
function $e7725b143600c9c2$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $e7725b143600c9c2$export$38b2d434cce3ea22(value).Element;
}
function $e7725b143600c9c2$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $e7725b143600c9c2$export$38b2d434cce3ea22(value).HTMLElement;
}
function $e7725b143600c9c2$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $e7725b143600c9c2$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $e7725b143600c9c2$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $e7725b143600c9c2$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $e7725b143600c9c2$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($e7725b143600c9c2$export$651544f548703224(element));
}
function $e7725b143600c9c2$export$d6c4e8150c35fed1(element) {
    const webkit = $e7725b143600c9c2$export$78551043582a6a98();
    const css = $e7725b143600c9c2$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $e7725b143600c9c2$export$940d8225183e1404(element) {
    let currentNode = $e7725b143600c9c2$export$4e12058fc4d51d56(element);
    while($e7725b143600c9c2$export$1b3bfaa9684536aa(currentNode) && !$e7725b143600c9c2$export$d1162fb0b6d4cd51(currentNode)){
        if ($e7725b143600c9c2$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $e7725b143600c9c2$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $e7725b143600c9c2$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $e7725b143600c9c2$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($e7725b143600c9c2$export$651544f548703224(node));
}
function $e7725b143600c9c2$export$3735103072e4a80(element) {
    return $e7725b143600c9c2$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $e7725b143600c9c2$export$dc8fc79fa2800137(element) {
    if ($e7725b143600c9c2$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $e7725b143600c9c2$export$4e12058fc4d51d56(node) {
    if ($e7725b143600c9c2$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $e7725b143600c9c2$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $e7725b143600c9c2$export$e495491855dc5418(node);
    return $e7725b143600c9c2$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $e7725b143600c9c2$export$7cd01a57c8ca906c(node) {
    const parentNode = $e7725b143600c9c2$export$4e12058fc4d51d56(node);
    if ($e7725b143600c9c2$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($e7725b143600c9c2$export$1b3bfaa9684536aa(parentNode) && $e7725b143600c9c2$export$989e911fa9af580a(parentNode)) return parentNode;
    return $e7725b143600c9c2$export$7cd01a57c8ca906c(parentNode);
}
function $e7725b143600c9c2$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $e7725b143600c9c2$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $e7725b143600c9c2$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $e7725b143600c9c2$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $e7725b143600c9c2$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $e7725b143600c9c2$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}

});


parcelRegister("3fOxZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25e9fb6a7fb483de$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
var $25e9fb6a7fb483de$var$index = (0, $iSvIT.useLayoutEffect);
var $25e9fb6a7fb483de$export$2e2bcd8739ae039 = $25e9fb6a7fb483de$var$index;

});


//# sourceMappingURL=language-selector.83403737.js.map
